(function() {
  function processCartData(data) {
    let items = [];
    if (data.items) {
      items = data.items;
    } else if (data.id) {
      items = [data];
    }

    if (items.length > 0) {
      let value = 0;
      let dlItems = items.map(item => {
        let itemPrice = (item.price || item.final_price || item.discounted_price || 0) / 100;
        value += itemPrice * item.quantity;
        return {
          item_id: item.sku || String(item.product_id || item.id),
          item_name: item.product_title || item.title || "",
          item_brand: item.vendor || "",
          price: itemPrice,
          item_category: item.product_type || "",
          item_variant: item.variant_title || "Default Title",
          quantity: item.quantity
        };
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          currency: (window.shopData && window.shopData.currency) ? window.shopData.currency : "BDT",
          value: value,
          items: dlItems
        }
      });
    }
  }

  // 1. Intercept Fetch API
  const originalFetch = window.fetch;
  window.fetch = async function() {
    const response = await originalFetch.apply(this, arguments);
    const url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] instanceof Request ? arguments[0].url : '');
    
    if (url.includes('/cart/add.js') || url.includes('/cart/add')) {
      const clone = response.clone();
      clone.json().then(data => {
        processCartData(data);
      }).catch(e => console.error('GA4 Fetch Intercept Error (add):', e));
    }
    
    return response;
  };

  // 2. Intercept XMLHttpRequest ($.ajax fallback)
  const originalXHR = window.XMLHttpRequest.prototype.open;
  window.XMLHttpRequest.prototype.open = function() {
    this.addEventListener('load', function() {
      if (this.responseURL && (this.responseURL.includes('/cart/add.js') || this.responseURL.includes('/cart/add'))) {
        try {
          const data = JSON.parse(this.responseText);
          processCartData(data);
        } catch(e) {}
      }
    });
    originalXHR.apply(this, arguments);
  };

  // 3. Intercept standard form submits
  document.addEventListener('submit', function(e) {
    let form = e.target;
    if (form && form.tagName === 'FORM' && form.getAttribute('action') && form.getAttribute('action').includes('/cart/add')) {
      if (e.defaultPrevented) return; // Already handled by AJAX script in theme

      e.preventDefault();
      
      let formData = new FormData(form);
      
      fetch(window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(res => res.json())
      .then(data => {
        processCartData(data);
        
        // Wait a tiny bit for GTM to process before redirecting
        setTimeout(() => {
          let returnTo = form.querySelector('input[name="return_to"]');
          if (returnTo && returnTo.value) {
            window.location.href = returnTo.value;
          } else {
            window.location.href = window.Shopify?.routes?.root ? window.Shopify.routes.root + 'cart' : '/cart';
          }
        }, 300);
      })
      .catch(err => {
        form.submit();
      });
    }
  });

  // Listen for checkout button clicks
  document.addEventListener('click', function(e) {
    let target = e.target.closest('button[name="checkout"], input[name="checkout"], a[href="/checkout"]');
    if (target) {
      if (window.shopData && window.shopData.cart) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: "begin_checkout",
          ecommerce: {
            currency: window.shopData.currency || "BDT",
            value: window.shopData.cart.value,
            items: window.shopData.cart.items
          }
        });
      }
    }
  });
})();
